module.exports = __webpack_public_path__ + "img/datav.5f39a6ad.jpg";